<!-- <div class="one" [formGroup]="SettingForm" fxLayout="column"> -->
<!-- <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
<mat-form-field appearance="outline" fxFlex="20" class="pr-1"
  [ngClass]="{'has-error':errorWarningData.Error?.ABN,'has-warning':errorWarningData.Warning?.ABN}">
  <mat-label>ABN</mat-label>
  <input name="ABN" formControlName="ABN" matInput>
  <mat-icon matSuffix class="secondary-text"></mat-icon>
</mat-form-field>
</div> -->

<!-- rate -->
<!-- ends here ~ rate -->

<!-- <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto"> -->
<!-- <mat-form-field appearance="outline" fxFlex="33" class="pr-1" *ngIf="!('' | productType)"
[ngClass]="{'has-error':errorWarningData.Error?.HOURLYBASERATE,'has-warning':errorWarningData.Warning?.HOURLYBASERATE}">
<mat-label>Hourly Rate</mat-label>
<input type="number" name="HOURLYBASERATE" formControlName="HOURLYBASERATE" matInput>
</mat-form-field>
<mat-form-field appearance="outline" fxFlex="34" class="pr-1" *ngIf="!('' | productType)"
  [ngClass]="{'has-error':errorWarningData.Error?.DAILYBASERATE,'has-warning':errorWarningData.Warning?.DAILYBASERATE}">
  <mat-label>Daily Rate</mat-label>
  <input type="number" name="DAILYBASERATE" formControlName="DAILYBASERATE" matInput>
</mat-form-field> -->

<!-- <mat-form-field appearance="outline" fxFlex="15" class="pr-1"
[ngClass]="{'has-error':errorWarningData.Error?.UNITSPERHOUR,'has-warning':errorWarningData.Warning?.UNITSPERHOUR}">
<mat-label>Unit Size</mat-label>
<mat-select name="UNITSPERHOUR" formControlName="UNITSPERHOUR" placeholder="Unit Size">
  <mat-option *ngFor="let val of getDropDownValue.UNITSPERHOUR" value="{{val.VALUE}}">{{val.DESCRIPTION}}
  </mat-option>
</mat-select>
</mat-form-field>

<ng-container  *ngIf="currentuser.PRODUCTTYPE == 'Solicitor'">
  <mat-form-field appearance="outline" fxFlex="25" class="pr-1"   [ngClass]="accessTierPermission[3]?.ALLOWED ==0  ? 'disabled-click large-button' : 'large-button'"
    [ngClass]="{'has-error':errorWarningData.Error?.MATTERDELIVERABLEGUID,'has-warning':errorWarningData.Warning?.MATTERDELIVERABLEGUID}">
    <mat-label>Will Your Firm Use Deliverables?</mat-label>
    <mat-select name="MATTERDELIVERABLEGUID" formControlName="MATTERDELIVERABLEGUID"  #value (selectionChange)="radioChange($event.value)" >
      <mat-option  *ngFor="let val of getDropDownValue.DELIVERABLEOPTIONS" value="{{val.VALUE}}">{{val.DESCRIPTION}}</mat-option> -->
<!-- <mat-option value="No">No</mat-option>
      <mat-option value="Mandatory">Mandatory</mat-option>
      <mat-option value="Optional">Optional</mat-option> -->
<!-- </mat-select>
  </mat-form-field>
</ng-container> -->
<!-- </div> -->
<!-- <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
<mat-form-field appearance="outline" fxFlex="15" class="pr-1"
  [ngClass]="{'has-error':errorWarningData.Error?.DUEDATEOFFSET,'has-warning':errorWarningData.Warning?.DUEDATEOFFSET}">
  <mat-label>Due Date Offset</mat-label>
  <input type="number" name="DUEDATEOFFSET" formControlName="DUEDATEOFFSET" matInput>
  <mat-icon matSuffix class="secondary-text"></mat-icon>
</mat-form-field>
<mat-form-field appearance="outline" fxFlex="25" class="pr-1"
  [ngClass]="{'has-error':errorWarningData.Error?.OFFICECHEQUEFORMAT,'has-warning':errorWarningData.Warning?.OFFICECHEQUEFORMAT}">
  <mat-label>Office Cheque Format</mat-label>
  <mat-select name="OFFICECHEQUEFORMAT" formControlName="OFFICECHEQUEFORMAT"
    placeholder="Office Cheque Format">
    <mat-option *ngFor="let val of getDropDownValue.OFFICECHEQUEFORMAT" value="{{val.VALUE}}">
    {{val.DESCRIPTION}}</mat-option>
  </mat-select>
</mat-form-field>
</div> -->
<!-- <div fxLayout="row" class="check" fxLayoutAlign="start center" fxFlex="1 0 auto">
<mat-checkbox name="USESINGLELINEEXPENSE" formControlName="USESINGLELINEEXPENSE" class="check_1">Use Single Line
  Expense
</mat-checkbox>

</div> -->
<!-- <div  *ngIf="'' | productType" fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
<mat-form-field appearance="outline" fxFlex="40" class="pr-1"
  [ngClass]="{'has-error':errorWarningData.Error?.RATEOVERRIDESEQUENCE,'has-warning':errorWarningData.Warning?.RATEOVERRIDESEQUENCE}">
  <mat-label>Time Entry Rate Calculation Sequence</mat-label>
  <mat-select name="RATEOVERRIDESEQUENCE" formControlName="RATEOVERRIDESEQUENCE"
    placeholder="Time Entry Rate Calculation Sequence">
    <mat-option value="0">Matter -> Contact -> Fee Earner </mat-option>
    <mat-option value="1">Matter -> Matter Class-> Fee Earner </mat-option>
  </mat-select>
</mat-form-field>
</div> -->
<!-- &nbsp;&nbsp; -->
<div
  [formGroup]="SettingForm"
  class="one"
  [ngClass]="class == true ? 'height-546' : 'height-545'"
  fxLayout="column"
>
  <div class="height-524 max-h-[calc(100dvh-230px)]">
    <mat-accordion class="faqs-accordion">
      <mat-expansion-panel
        label="Decide how time entries are calculated and grouped"
        mat-align-tabs="start"
        fxLayout="column"
      >
        <mat-expansion-panel-header class="Bold_panel_header">
          Decide how time entries are calculated and grouped
        </mat-expansion-panel-header>
        <div class="border-line"></div>
        <div class="one" [formGroup]="SettingForm" fxLayout="column">
          <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto">
            <mat-form-field appearance="outline" class="entry-input pr-1">
              <mat-label>Default Matter GST Type</mat-label>
              <mat-select name="GSTTYPE" formControlName="GSTTYPE" placeholder="Select an option">
                <mat-option value="GST Exclusive">GST Exclusive</mat-option>
                <mat-option value="GST Inclusive">GST Inclusive</mat-option>
                <mat-option value="GST Free">GST Free</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              class="entry-input pr-1"
              [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.UNITSPERHOUR),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.UNITSPERHOUR),
              }"
            >
              <mat-label>Unit Size</mat-label>
              <mat-select
                name="UNITSPERHOUR"
                formControlName="UNITSPERHOUR"
                placeholder="Unit Size"
              >
                @for (val of getDropDownValue.UNITSPERHOUR; track val) {
                  <mat-option value="{{ val.DESCRIPTION }}">
                    {{ val.DESCRIPTION }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            @if (
              ('Matter Deliverables' | tierPermission: 'Matter Deliverables') &&
              ('Matter Deliverables' | tierPermission: 'Matter Deliverables').ALLOWED == 1
            ) {
              <mat-form-field
                appearance="outline"
                class="entry-input-1 pr-1"
                [ngClass]="
                  appPermissions?.[32]?.Access == 0 ? 'disabled-click large-button' : 'large-button'
                "
                [ngClass]="{
                  'has-error': $safeNavigationMigration(
                    errorWarningData.Error?.MATTERDELIVERABLEGUID
                  ),
                  'has-warning': $safeNavigationMigration(
                    errorWarningData.Warning?.MATTERDELIVERABLEGUID
                  ),
                }"
              >
                <mat-label>Will You Be Using Deliverables?</mat-label>
                <mat-select
                  name="MATTERDELIVERABLEGUID"
                  formControlName="MATTERDELIVERABLEGUID"
                  #value
                  (selectionChange)="radioChange($event.value)"
                >
                  @for (val of getDropDownValue.DELIVERABLEOPTIONS; track val) {
                    <mat-option value="{{ val.VALUE }}">
                      {{ val.DESCRIPTION }}
                    </mat-option>
                  }
                  <!-- <mat-option value="No">No</mat-option>
                  <mat-option value="Mandatory">Mandatory</mat-option>
                  <mat-option value="Optional">Optional</mat-option> -->
                </mat-select>
              </mat-form-field>
            }
            <mat-form-field
              appearance="outline"
              class="entry-input pr-1"
              [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.DUEDATEOFFSET),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DUEDATEOFFSET),
              }"
            >
              <!-- <mat-label>Invoice Terms</mat-label> -->
              <mat-label>Due Date Offset</mat-label>
              <input type="number" name="DUEDATEOFFSET" formControlName="DUEDATEOFFSET" matInput />
              <mat-icon matSuffix class="secondary-text"></mat-icon>
            </mat-form-field>
            <!-- <mat-form-field appearance="outline" fxFlex="25" class="pr-1"
              [ngClass]="{'has-error':errorWarningData.Error?.OFFICECHEQUEFORMAT,'has-warning':errorWarningData.Warning?.OFFICECHEQUEFORMAT}">
              <mat-label>Office Cheque Format</mat-label>
              <mat-select name="OFFICECHEQUEFORMAT" formControlName="OFFICECHEQUEFORMAT"
                placeholder="Office Cheque Format">
                <mat-option *ngFor="let val of getDropDownValue.OFFICECHEQUEFORMAT" value="{{val.VALUE}}">
                {{val.DESCRIPTION}}</mat-option>
              </mat-select>
            </mat-form-field> -->
            <!-- <mat-radio-group name="GSTTYPE" formControlName="GSTTYPE" aria-label="Select an option"
            class="pr-1">
            <mat-radio-button value="0">GST Exclusive</mat-radio-button>
          </mat-radio-group>
          <mat-radio-group name="GSTTYPE" formControlName="GSTTYPE" aria-label="Select an option"
            class="pr-1 ml-5">
            <mat-radio-button value="1">GST Inclusive</mat-radio-button>
          </mat-radio-group>
          <mat-radio-group name="GSTTYPE" formControlName="GSTTYPE" aria-label="Select an option"
            class="pr-1 ml-5">
            <mat-radio-button value="2">GST Free</mat-radio-button>
          </mat-radio-group> -->
          </div>
          @if (currentUser.PRODUCTTYPE == 'Barrister') {
            <div>
              <div fxFlex="14"></div>
              <div fxFlex="15" class="text-center">
                <mat-label>{{ CurrenctSymbol }} / hr</mat-label>
              </div>
              <div fxFlex="15" class="text-center">
                <mat-label>{{ CurrenctSymbol }} / day</mat-label>
              </div>
            </div>
            @if (rateList.length > 0) {
              <div class="mat-rate-list">
                <div fxFlex="14" class="lable-div">
                  <mat-label>{{ rateList[0].LOOKUPFULLVALUE }}</mat-label>
                </div>
                <mat-form-field appearance="outline" class="example" fxFlex="15" class="pr-1">
                  <input
                    matInput
                    formControlName="HOURLYBASERATE"
                    style="text-align: right"
                    type="text"
                    mask="separator.2"
                    thousandSeparator=","
                    decimalMarker="."
                    [leadZero]="true"
                  />
                </mat-form-field>
                <mat-form-field appearance="outline" class="example" fxFlex="15" class="pr-1">
                  <input
                    matInput
                    formControlName="DAILYBASERATE"
                    style="text-align: right"
                    type="text"
                    mask="separator.2"
                    thousandSeparator=","
                    decimalMarker="."
                    [leadZero]="true"
                  />
                </mat-form-field>
              </div>
              <div class="mat-rate-list">
                <div fxFlex="14" class="lable-div">
                  <mat-label>{{ rateList[1].LOOKUPFULLVALUE }}</mat-label>
                </div>
                <mat-form-field appearance="outline" class="example" fxFlex="15" class="pr-1">
                  <input
                    matInput
                    formControlName="HOURLYBASERATE2"
                    style="text-align: right"
                    type="text"
                    mask="separator.2"
                    thousandSeparator=","
                    decimalMarker="."
                    [leadZero]="true"
                  />
                </mat-form-field>
                <mat-form-field appearance="outline" class="example" fxFlex="15" class="pr-1">
                  <input
                    matInput
                    formControlName="DAILYBASERATE2"
                    style="text-align: right"
                    type="text"
                    mask="separator.2"
                    thousandSeparator=","
                    decimalMarker="."
                    [leadZero]="true"
                  />
                </mat-form-field>
              </div>
              <div class="mat-rate-list">
                <div fxFlex="14" class="lable-div">
                  <mat-label>{{ rateList[2].LOOKUPFULLVALUE }}</mat-label>
                </div>
                <mat-form-field appearance="outline" class="example" fxFlex="15" class="pr-1">
                  <input
                    matInput
                    formControlName="HOURLYBASERATE3"
                    style="text-align: right"
                    type="text"
                    mask="separator.2"
                    thousandSeparator=","
                    decimalMarker="."
                    [leadZero]="true"
                  />
                </mat-form-field>
                <mat-form-field appearance="outline" class="example" fxFlex="15" class="pr-1">
                  <input
                    matInput
                    formControlName="DAILYBASERATE3"
                    style="text-align: right"
                    type="text"
                    mask="separator.2"
                    thousandSeparator=","
                    decimalMarker="."
                    [leadZero]="true"
                  />
                </mat-form-field>
              </div>
              <div class="mat-rate-list">
                <div fxFlex="14" class="lable-div">
                  <mat-label>{{ rateList[3].LOOKUPFULLVALUE }}</mat-label>
                </div>
                <mat-form-field appearance="outline" class="example" fxFlex="15" class="pr-1">
                  <input
                    matInput
                    formControlName="HOURLYBASERATE4"
                    style="text-align: right"
                    type="text"
                    mask="separator.2"
                    thousandSeparator=","
                    decimalMarker="."
                    [leadZero]="true"
                  />
                </mat-form-field>
                <mat-form-field appearance="outline" class="example" fxFlex="15" class="pr-1">
                  <input
                    matInput
                    formControlName="DAILYBASERATE4"
                    style="text-align: right"
                    type="text"
                    mask="separator.2"
                    thousandSeparator=","
                    decimalMarker="."
                    [leadZero]="true"
                  />
                </mat-form-field>
              </div>
              <div class="mat-rate-list">
                <div fxFlex="14" class="lable-div">
                  <mat-label>{{ rateList[4].LOOKUPFULLVALUE }}</mat-label>
                </div>
                <mat-form-field appearance="outline" class="example" fxFlex="15" class="pr-1">
                  <input
                    matInput
                    formControlName="HOURLYBASERATE5"
                    style="text-align: right"
                    type="text"
                    mask="separator.2"
                    thousandSeparator=","
                    decimalMarker="."
                    [leadZero]="true"
                  />
                </mat-form-field>
                <mat-form-field appearance="outline" class="example" fxFlex="15" class="pr-1">
                  <input
                    matInput
                    formControlName="DAILYBASERATE5"
                    style="text-align: right"
                    type="text"
                    mask="separator.2"
                    thousandSeparator=","
                    decimalMarker="."
                    [leadZero]="true"
                  />
                </mat-form-field>
              </div>
              <div class="mat-rate-list">
                <div fxFlex="14" class="lable-div">
                  <mat-label>{{ rateList[5].LOOKUPFULLVALUE }}</mat-label>
                </div>
                <mat-form-field appearance="outline" class="example" fxFlex="15" class="pr-1">
                  <input
                    matInput
                    style="text-align: right"
                    formControlName="HOURLYBASERATE6"
                    type="text"
                    mask="separator.2"
                    thousandSeparator=","
                    decimalMarker="."
                    [leadZero]="true"
                  />
                </mat-form-field>
                <mat-form-field appearance="outline" class="example" fxFlex="15" class="pr-1">
                  <input
                    matInput
                    style="text-align: right"
                    formControlName="DAILYBASERATE6"
                    type="text"
                    mask="separator.2"
                    thousandSeparator=","
                    decimalMarker="."
                    [leadZero]="true"
                  />
                </mat-form-field>
              </div>
            }
          }
          @if ('' | productType) {
            <div fxLayout="row" class="check mb-4" fxLayoutAlign="start center" fxFlex="1 0 auto">
              <mat-checkbox
                name="VENDORISLIABLEFORSETTLEMENTDATE"
                formControlName="VENDORISLIABLEFORSETTLEMENTDATE"
                class="entry-input-3"
              >
                Vendor Is Liable For Settlement Day
              </mat-checkbox>
              @if ('' | productType) {
                <mat-form-field
                  appearance="outline"
                  class="entry-input-2 pr-1"
                  [ngClass]="{
                    'has-error': $safeNavigationMigration(
                      errorWarningData.Error?.RATEOVERRIDESEQUENCE
                    ),
                    'has-warning': $safeNavigationMigration(
                      errorWarningData.Warning?.RATEOVERRIDESEQUENCE
                    ),
                  }"
                >
                  <mat-label>Time Entry Rate Calculation Sequence</mat-label>
                  <mat-select
                    name="RATEOVERRIDESEQUENCE"
                    formControlName="RATEOVERRIDESEQUENCE"
                    placeholder="Time Entry Rate Calculation Sequence"
                  >
                    <mat-option value="Matter -> Contact -> Fee Earner">
                      Matter -> Contact -> Fee Earner
                    </mat-option>
                    <mat-option value="Matter -> Matter Class -> Fee Earner">
                      Matter -> Matter Class-> Fee Earner
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              }
            </div>
          }

          <div class="pt-4">
            <mat-dialog-actions class="popup_ftr justify-end!">
              <button
                class="mainbtn_size"
                matButton="filled"
                [disabled]="isspinerTE"
                (click)="saveTimeEntries()"
              >
                @if (isspinerTE) {
                  <mat-spinner diameter="24"></mat-spinner>
                }
                Save
              </button>
              <!-- <button class="btn_2" mat-raised-button color="primary" cdkFocusInitial>Don't Save</button> -->
            </mat-dialog-actions>
          </div>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel
        label="Choose your defaults and which fields are required"
        mat-align-tabs="start"
        fxLayout="column"
      >
        <mat-expansion-panel-header class="Bold_panel_header">
          Choose your defaults and which fields are required
        </mat-expansion-panel-header>
        <app-defaults
          [getDropDownValue]="getDropDownValue"
          [errorWarningData]="errorWarningData"
          [SettingForm]="SettingForm"
        ></app-defaults>
      </mat-expansion-panel>

      <mat-expansion-panel
        label="Change the descriptions of rates"
        mat-align-tabs="start"
        fxLayout="column"
      >
        <mat-expansion-panel-header class="Bold_panel_header">
          Change the descriptions of rates
        </mat-expansion-panel-header>
        <div class="one" [formGroup]="SettingForm" fxLayout="column">
          <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto" class="mb-4">
            <mat-form-field
              appearance="outline"
              class="entry-input pr-1"
              [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.RATEDESCRIPTION1),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.RATEDESCRIPTION1),
              }"
            >
              <mat-label>Rate 1 Description</mat-label>
              <input
                type="text"
                name="RATEDESCRIPTION1"
                formControlName="RATEDESCRIPTION1"
                matInput
              />
              <mat-icon matSuffix class="secondary-text"></mat-icon>
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              class="entry-input pr-1"
              [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.RATEDESCRIPTION2),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.RATEDESCRIPTION2),
              }"
            >
              <mat-label>Rate 2 Description</mat-label>
              <input
                type="text"
                name="RATEDESCRIPTION2"
                formControlName="RATEDESCRIPTION2"
                matInput
              />
              <mat-icon matSuffix class="secondary-text"></mat-icon>
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              class="entry-input pr-1"
              [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.RATEDESCRIPTION3),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.RATEDESCRIPTION3),
              }"
            >
              <mat-label>Rate 3 Description</mat-label>
              <input
                type="text"
                name="RATEDESCRIPTION3"
                formControlName="RATEDESCRIPTION3"
                matInput
              />
              <mat-icon matSuffix class="secondary-text"></mat-icon>
            </mat-form-field>
          </div>
          <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto" class="mb-4">
            <mat-form-field
              appearance="outline"
              class="entry-input pr-1"
              [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.RATEDESCRIPTION4),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.RATEDESCRIPTION4),
              }"
            >
              <mat-label>Rate 4 Description</mat-label>
              <input
                type="text"
                name="RATEDESCRIPTION4"
                formControlName="RATEDESCRIPTION4"
                matInput
              />
              <mat-icon matSuffix class="secondary-text"></mat-icon>
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              class="entry-input pr-1"
              [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.RATEDESCRIPTION5),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.RATEDESCRIPTION5),
              }"
            >
              <mat-label>Rate 5 Description</mat-label>
              <input
                type="text"
                name="RATEDESCRIPTION5"
                formControlName="RATEDESCRIPTION5"
                matInput
              />
              <mat-icon matSuffix class="secondary-text"></mat-icon>
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              class="entry-input pr-1"
              [ngClass]="{
                'has-error': $safeNavigationMigration(errorWarningData.Error?.RATEDESCRIPTION6),
                'has-warning': $safeNavigationMigration(errorWarningData.Warning?.RATEDESCRIPTION6),
              }"
            >
              <mat-label>Rate 6 Description</mat-label>
              <input
                type="text"
                name="RATEDESCRIPTION6"
                formControlName="RATEDESCRIPTION6"
                matInput
              />
              <mat-icon matSuffix class="secondary-text"></mat-icon>
            </mat-form-field>
          </div>
          <div class="pt-4">
            <mat-dialog-actions class="popup_ftr justify-end!">
              <button
                class="mainbtn_size"
                matButton="filled"
                [disabled]="isspinerRates"
                (click)="saveRates()"
              >
                @if (isspinerRates) {
                  <mat-spinner diameter="24"></mat-spinner>
                }
                Save
              </button>
              <!-- <button class="btn_2" mat-raised-button color="primary" cdkFocusInitial>Don't Save</button> -->
            </mat-dialog-actions>
          </div>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel
        label="Nominate the threshold you would like to receive a warning when you are nearing your estimate amount"
        mat-align-tabs="start"
        fxLayout="column"
        class="header-disp"
      >
        <mat-expansion-panel-header class="Bold_panel_header">
          Nominate the threshold you would like to receive a warning when you are nearing your
          estimate amount
        </mat-expansion-panel-header>
        <div class="text-disp text-[14px]">
          Eg. if you set the percentage to 20% then the warning will occur when you are within 20%
          of the estimate
        </div>
        <br />
        <div class="border-line"></div>
        <app-estimates-setting
          [errorWarningData]="errorWarningData"
          [SettingForm]="SettingForm"
        ></app-estimates-setting>
      </mat-expansion-panel>

      <mat-expansion-panel label="Regional Settings" mat-align-tabs="start" fxLayout="column">
        <mat-expansion-panel-header class="Bold_panel_header">
          Set your region and tax settings
        </mat-expansion-panel-header>
        <app-reginoal-setting
          [getDropDownValue]="getDropDownValue"
          [errorWarningData]="errorWarningData"
          [SettingForm]="SettingForm"
        ></app-reginoal-setting>
      </mat-expansion-panel>

      @if (currentUser.PRODUCTTYPE == 'Barrister') {
        <mat-expansion-panel label="Clerk Settings" mat-align-tabs="start" fxLayout="column">
          <mat-expansion-panel-header class="Bold_panel_header">
            Clerk Settings
          </mat-expansion-panel-header>
          <div class="one" [formGroup]="SettingForm" fxLayout="column">
            <span>
              Clerk % (ex GST)
              <mat-form-field appearance="outline" class="region-input pr-1">
                <mat-label>Clerk % (ex GST)</mat-label>
                <input type="number" formControlName="CLERKRATE" matInput />
              </mat-form-field>
              of the GST Inc invoice total
            </span>
          </div>
          <div class="pt-4">
            <mat-dialog-actions class="popup_ftr justify-end!">
              <button
                class="mainbtn_size"
                matButton="filled"
                [disabled]="isspinerRates"
                (click)="saveClerk()"
              >
                @if (isspinerRates) {
                  <mat-spinner diameter="24"></mat-spinner>
                }
                Save
              </button>
              <!-- <button class="btn_2" mat-raised-button color="primary" cdkFocusInitial>Don't Save</button> -->
            </mat-dialog-actions>
          </div>
        </mat-expansion-panel>
      }
      @if (
        currentUser.PRODUCTTYPE == 'Solicitor' &&
        ('Trust Accounts' | tierPermission: 'Trust Accounts') &&
        ('Trust Accounts' | tierPermission: 'Trust Accounts').ALLOWED == 1
      ) {
        <mat-expansion-panel label="Trust" mat-align-tabs="start" fxLayout="column">
          <mat-expansion-panel-header class="Bold_panel_header">
            Define your Trust settings
          </mat-expansion-panel-header>
          @if (getDropDownValue && getDropDownValue.FIRSTTRUSTMONTH) {
            @if (getDropDownValue.FIRSTTRUSTMONTH.length > 0) {
              <app-trust
                [getDropDownValue]="getDropDownValue"
                [errorWarningData]="errorWarningData"
                [SettingForm]="SettingForm"
              ></app-trust>
            }
          }
        </mat-expansion-panel>
      }

      <mat-expansion-panel
        label="Practice Account Details"
        mat-align-tabs="start"
        fxLayout="column"
      >
        <mat-expansion-panel-header class="Bold_panel_header">
          Practice Account Details
        </mat-expansion-panel-header>
        <app-practice-account-details
          [getDropDownValue]="getDropDownValue"
          [errorWarningData]="errorWarningData"
          [SettingForm]="SettingForm"
        ></app-practice-account-details>
      </mat-expansion-panel>

      @if (currentUser.PRODUCTTYPE == 'Solicitor') {
        <mat-expansion-panel
          label="Create specific rates per matter class"
          mat-align-tabs="start"
          fxLayout="column"
        >
          <mat-expansion-panel-header class="Bold_panel_header">
            Create specific rates per matter class
          </mat-expansion-panel-header>
          <div class="border-line"></div>
          <app-matter-rates [SettingForm]="SettingForm"></app-matter-rates>
        </mat-expansion-panel>
      }
    </mat-accordion>
  </div>
</div>
<div align="end">
  <mat-dialog-actions class="popup_ftr">
    <button class="mainbtn_size" matButton="filled" [disabled]="isspiner" (click)="saveBS()">
      @if (isspiner) {
        <mat-spinner diameter="24"></mat-spinner>
      }
      Save
    </button>
    <!-- <button class="btn_2" mat-raised-button color="primary" cdkFocusInitial>Don't Save</button> -->
  </mat-dialog-actions>
</div>
<!-- </div> -->
